import { SSUType } from "../types";
import { LeadDataSSUType } from "./leadDataTypes";

export const leadDataSSUTypePredicate = (
  arg: SSUType
): arg is LeadDataSSUType => {
  return (arg as LeadDataSSUType).name !== undefined;
};
